<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable>
      <v-card>
        <v-toolbar flat dark color="primary" class="max-height">
          <v-toolbar-title> Detalle de Plan de Pagos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog"> <v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-progress-linear v-if="persona_loading" indeterminate color="indigo"></v-progress-linear>
          <v-row v-if="persona.id">
            <v-col>
              <p class="mb-0">
                <b>Estudiante:</b> {{ persona.nombres }} {{ persona.primer_apellido }} {{ persona.segundo_apellido }}
              </p>
              <p class="mb-0"><b>Documento:</b> {{ persona.numero_documento }}</p>
              <p class="mb-0">
                <b>WhatsApp:</b>
                <a :href="`${apiwhatsapp}` + persona.telefono1" target="_blank"> {{ persona.telefono1 }} </a>
              </p>
              <p class="mb-0"><b>Inscripcion:</b> {{ inscripcion_id }}</p>
            </v-col>

            <v-col>
              <p class="mb-0"><b>Fecha nac:</b> {{ persona.fecha_nacimiento }}</p>
              <p class="mb-0"><b>Correo:</b> {{ persona.email }}</p>
              <p class="mb-0"><b>Profesion:</b> {{ parseprofesiones(persona.profesiones) }}</p>
            </v-col>

            <v-col>
              <p class="mb-0"><b>Ciudad:</b> {{ parseciudad(persona.ciudad) }}</p>
              <p class="mb-0"><b>Domicilio:</b> {{ persona.domicilio }}</p>
              <p class="mb-0"><b>Institucion:</b> {{ parseinstitucion(persona.institucion) }}</p>
            </v-col>
          </v-row>
          <hr />

          <p v-for="(t, ind) in xtotales" :key="ind" class="mb-0">
            <b>{{ t.concepto_pago }}: </b> <span> {{ parsecomas(t.total) }} </span>
          </p>
          <v-data-table
            :headers="headers"
            hide-default-footer
            disable-pagination
            :items="plan_pagos"
            :item-class="itemRowBackground"
            class="elevation-1"
          >
            <template v-slot:[`item.total`]="{ item }">
              <span> {{ item.total }} </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        apiwhatsapp: process.env.VUE_APP_API_WHATSAPP,
        dialog: false,
        xtotales: [],
        plan_pagos: [],
        persona: {},
        inscripcion_id: '',
        persona_loading: false,
        headers: [
          // { text: 'Codigo-Cuota', value: 'id' },
          { text: 'Concepto', value: 'concepto_pago' },
          { text: 'N°Cuota', value: 'nro_cuota' },
          { text: 'Monto Total', value: 'total' },
          { text: 'Monto Pagado', value: 'monto_pagado' },
          { text: 'Monto Descuento', value: 'monto_descuento' },
          { text: 'Monto Regularizado', value: 'monto_regularizado' },
          { text: 'Monto Compensacion', value: 'monto_compensacion' },
          { text: 'Monto Liquido', value: 'monto_liquido' },
          { text: 'Fecha Vencimiento', value: 'fecha_pago', width: 120 },
        ],
      };
    },
    watch: {
      dialog(val) {
        val || this.closeDialog();
      },
    },
    methods: {
      showThisView(plan_pagos = [], idpersona, inscripcion_id) {
        // window.console.log(JSON.stringify(plan_pagos));
        this.parsePagos(plan_pagos);
        this.inscripcion_id = inscripcion_id;
        this.plan_pagos = plan_pagos;
        this.dialog = true;
        this.persona = {};
        if (idpersona) this.getpersonainfo(idpersona);
      },
      itemRowBackground: function(item) {
        return item.concepto_pago == 'Totales' ? 'green darken-2 white--text' : '';
      },
      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      closeDialog() {
        this.plan_pagos = [];
        this.dialog = false;
      },
      getpersonainfo(idpersona) {
        this.persona_loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/esam/persona/id/${idpersona}`;
        xaxios.get(url).then(({ data }) => {
          vue.persona = data.persona;
          vue.persona_loading = false;
          //window.console.log(data);
        });
      },
      parseprofesiones(ps) {
        if (!ps) return '';
        let txt = '';
        ps.forEach((e) => {
          txt += e.nombre;
        });
        return txt;
      },
      parseciudad(c) {
        if (!c) return '';
        return c.nombre;
      },
      parseinstitucion(i) {
        if (!i) return '';
        return i.nombre;
      },
      parsePagos(plan) {
        let totales = {};
        totales.concepto_pago = 'Totales';
        totales.total = 0;
        totales.monto_pagado = 0;
        totales.monto_descuento = 0;
        totales.monto_regularizado = 0;
        totales.monto_compensacion = 0;
        totales.monto_liquido = 0;
        this.xtotales = [];
        let xts = [];
        let xtotal = {};
        xtotal.concepto_pago = '';
        xtotal.total = 0;
        // window.console.log(plan);
        plan.forEach((x) => {
          totales.total += x.total;
          totales.monto_pagado += x.monto_pagado;
          totales.monto_descuento += x.monto_descuento;
          totales.monto_regularizado += x.monto_regularizado;
          totales.monto_compensacion += x.monto_compensacion;
          totales.monto_liquido += x.monto_liquido;
          let xt = xts.find((t) => t.concepto_pago == x.concepto_pago);
          if (xt) {
            xt.total += x.total;
          } else {
            let xtotal = {};
            xtotal.concepto_pago = x.concepto_pago;
            xtotal.total = x.total;
            xts.push(xtotal);
          }
        });
        this.xtotales = xts;
        plan.push(totales);
      },
    },
  };
</script>

<style></style>
